import React, { useEffect, useState } from "react";
import Select from "react-select";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import api from "~/services/api";

export default function ModalFilters({ opened, onClose, onApplyFilters }) {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!opened) return;
    let active = true;
    setLoading(true);
    api.get("/paymentmethods/options")
      .then(({ data }) => {
        if (active) setPaymentMethods(data || []);
      })
      .catch(() => {
        if (active) toast.error("Failed to load payment methods.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [opened]);

  if (!opened) return null;

  const options = paymentMethods.map((method) => ({
    value: method.id,
    label: method.description,
  }));

  const handleApply = () => {
    if (paymentMethodId && !options.some((option) => option.value === paymentMethodId)) {
      toast.error("Select a payment method from the list.");
      return;
    }
    onApplyFilters(paymentMethodId);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex justify-end items-center py-6"
      style={{ backgroundColor: "rgba(0,0,0,.75)" }}
      onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}
    >
      <div className="bg-white w-full max-w-md h-full flex flex-col shadow-2xl rounded-l-2xl">
        <div className="flex items-center justify-between px-6 py-6 border-b border-gray-200">
          <div>
            <h2 className="text-lg font-bold text-gray-900 uppercase">Filters</h2>
            <p className="text-xs text-gray-500">Refine your search results</p>
          </div>
          <button type="button" aria-label="Close filters" onClick={onClose} className="p-2 text-gray-500 hover:bg-gray-100 rounded-md">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 px-6 py-6">
          <label htmlFor="settlement-payment-method" className="block text-xs font-bold text-gray-600 uppercase mb-2">
            Payment Method
          </label>
          <Select
            inputId="settlement-payment-method"
            options={options}
            value={options.find((option) => option.value === paymentMethodId) || null}
            onChange={(option) => setPaymentMethodId(option?.value || "")}
            isSearchable
            isClearable
            isLoading={loading}
            placeholder="All payment methods"
          />
        </div>
        <div className="px-6 py-6 border-t border-gray-200 bg-gray-50 flex flex-col gap-3">
          <button type="button" onClick={() => setPaymentMethodId("")} className="w-full py-2 text-sm text-red-600 bg-white border border-red-100 rounded-lg">
            Clean All Filters
          </button>
          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 text-sm bg-white border border-gray-300 rounded-lg">Cancel</button>
            <button type="button" onClick={handleApply} disabled={loading} className="flex-1 px-4 py-2 text-sm text-white bg-sky-700 rounded-lg disabled:opacity-50">Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
}
